/**
 * Setup Tour step definitions.
 *
 * Each step targets a DOM element via `data-tour="<targetId>"`.
 * All steps live on the settings page.
 */

export interface SetupTourStep {
  id: string;
  /** CSS selector used to find the target element */
  targetSelector: string;
  title: string;
  text: string;
  /** Which settings tab this step lives on */
  settingsTab: string;
  /** Preferred tooltip placement */
  placement?: 'top' | 'bottom' | 'left' | 'right';
}

export const SETUP_TOUR_STEPS: SetupTourStep[] = [
  {
    id: 'branding-tab',
    targetSelector: '[data-tour="settings-branding"]',
    title: 'tour.setup_branding.title',
    text: 'tour.setup_branding.text',
    settingsTab: 'branding',
    placement: 'bottom',
  },
  {
    id: 'templates-tab',
    targetSelector: '[data-tour="settings-templates"]',
    title: 'tour.setup_templates.title',
    text: 'tour.setup_templates.text',
    settingsTab: 'templates',
    placement: 'bottom',
  },
  {
    id: 'library-tab',
    targetSelector: '[data-tour="settings-library"]',
    title: 'tour.setup_library.title',
    text: 'tour.setup_library.text',
    settingsTab: 'library',
    placement: 'bottom',
  },
];
